import { BarChart3, FolderOpen, ListChecks, Settings2, TrendingUp } from 'lucide-react';
import type { ModuloWeb } from '../../nucleo/modulos-web';
import { BotaoAtalhoTarefas } from './AtalhoTarefas';
import { PaginaAtividades } from './PaginaAtividades';
import { PaginaComercial } from './PaginaComercial';
import { PaginaConfiguracoes } from './PaginaConfiguracoesCrm';
import { PaginaRelatoriosCrm } from './PaginaRelatoriosCrm';
import { CentralArquivosCrm } from './CentralArquivos';
import { SeloAtrasadas } from './SeloAtrasadas';
import { Equipes } from './Equipes';
import { ListaAtividades } from './ListaAtividades';
import { Metas } from './Metas';
import { MotivosPerda } from './MotivosPerda';
import { Quadro } from './Quadro';
import { buscaPipeline, copilotoPipeline } from './busca-copiloto';
import { criacoesPipeline } from './criacoes';
import { i18n } from './i18n';

const modulo: ModuloWeb = {
  slug: 'pipeline',
  menu: 'comercial',
  ordem: 10,
  abas: [
    { chave: 'pipeline', permissao: 'pipeline.ver', componente: Quadro },
    { chave: 'equipes', avancada: true, permissao: 'pipeline.ver', componente: Equipes },
    { chave: 'metas', avancada: true, permissao: 'pipeline.ver', componente: Metas },
    { chave: 'motivos-perda', avancada: true, permissao: 'pipeline.ver', componente: MotivosPerda },
    { chave: 'atividades', permissao: 'pipeline.ver', componente: ListaAtividades },
  ],
  // CRM novo desenho, lote 6: negociações na busca da barra superior e as perguntas do Copiloto (simuladas).
  buscaGlobal: buscaPipeline,
  copiloto: copilotoPipeline,
  atalhoTarefas: BotaoAtalhoTarefas,
  // CRM no novo desenho (lotes 2 a 5): as páginas do CRM do clone do RD na casca nova. Rodada crm1 (SPEC-M2): as Configurações
  // do CRM entram na barra lateral do CRM, no fim (e em Admin > Configurações > CRM).
  paginasCasca: [
    { chave: 'comercial', caminho: 'crm/comercial', componente: PaginaComercial, permissao: 'pipeline.ver', pagina: 'pipeline.pipeline', icone: TrendingUp, posicao: 10 },
    { chave: 'atividades', caminho: 'crm/atividades', componente: PaginaAtividades, permissao: 'pipeline.ver', pagina: 'pipeline.atividades', icone: ListChecks, posicao: 20, selo: SeloAtrasadas },
    // Lista de 02/11: a página Relatórios (funil de hoje, evolução, origem, parados), com a mesma permissão e a mesma página do papel do Comercial.
    { chave: 'relatorios', caminho: 'crm/relatorios', componente: PaginaRelatoriosCrm, permissao: 'pipeline.ver', pagina: 'pipeline.pipeline', icone: BarChart3, posicao: 60 },
    { chave: 'configuracoes', caminho: 'crm/configuracoes', componente: PaginaConfiguracoes, permissao: 'pipeline.configurar', icone: Settings2, posicao: 90 },
    // Rodada rlote-2 (SPEC-B1): Preferências > Central de Arquivos com rota própria (a mais específica vence a das Configurações):
    // abre para quem vê o comercial (os compartilhados, em leitura) e para quem gere a Central sem configurar o CRM; fora da barra.
    { chave: 'central', caminho: 'crm/configuracoes/preferencias/arquivos', componente: CentralArquivosCrm, permissao: ['pipeline.ver', 'pipeline.arquivos'], icone: FolderOpen, posicao: 91, semMenu: true },
  ],
  // Ajustes do CRM 27/10 (C6, K2): negociação, tarefa e funil no botão flutuante e no "Criar".
  criacoes: criacoesPipeline,
  i18n,
};

export default modulo;
